import {
    GET_SETTINGS,
    GET_SETTINGS_SUCCESS,
    GET_SETTINGS_FAILURE,
    UPDATE_SETTING_STATUS,
    UPDATE_SETTING_STATUS_SUCCESS,
    UPDATE_SETTING_STATUS_FAILURE,
    DELETE_SETTING,
    DELETE_SETTING_SUCCESS,
    DELETE_SETTING_FAILURE,
    ADD_SETTING,
    ADD_SETTING_SUCCESS,
    ADD_SETTING_FAILURE,
    EDIT_SETTING,
    EDIT_SETTING_SUCCESS,
    EDIT_SETTING_FAILURE,
    UPDATE_SETTINGS_ORDER_STATUS,
    UPDATE_SETTINGS_ORDER_STATUS_SUCCESS,
    UPDATE_SETTINGS_ORDER_STATUS_FAILURE
} from "../Constants";

const init = {
    data: {},
    delete_data: {},
    edit_data: {},
    add_data: {},
    update_data: {},
};

const SettingsReducer = (state = init, action) => {
    switch (action.type) {
        case GET_SETTINGS:
            return { ...state, loading: true };
        case GET_SETTINGS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_SETTINGS_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case DELETE_SETTING:
            return { ...state, loading: true };
        case DELETE_SETTING_SUCCESS:
            return { ...state, loading: false, delete_data: action.payload };
        case DELETE_SETTING_FAILURE:
            return { ...state, loading: false, delete_data: action.payload };       
        case UPDATE_SETTING_STATUS:
            return { ...state, loading: true };
        case UPDATE_SETTING_STATUS_SUCCESS:
            return { ...state, loading: false, update_data: action.payload };
        case UPDATE_SETTING_STATUS_FAILURE:
            return { ...state, loading: false, update_data: action.payload };
        case ADD_SETTING:
            return { ...state, loading: true };
        case ADD_SETTING_SUCCESS:
            return { ...state, loading: false, add_data: action.payload };
        case ADD_SETTING_FAILURE:
            return { ...state, loading: false, add_data: action.payload };
        case EDIT_SETTING:
            return { ...state, loading: true };
        case EDIT_SETTING_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_SETTING_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        case UPDATE_SETTINGS_ORDER_STATUS:
            return { ...state, loading: true };
        case UPDATE_SETTINGS_ORDER_STATUS_SUCCESS:
            return { ...state, loading: false, order_data: action.payload };
        case UPDATE_SETTINGS_ORDER_STATUS_FAILURE:
            return { ...state, loading: false, order_data: action.payload };
        default:
            return state;
        }
};

export default SettingsReducer;